<template>
  <PageArticle />
</template>

<script setup lang="ts">
definePageMeta({
  scrollToTop: true,
});
</script>

<style lang="scss" scoped></style>
